/**
 * Position of image in a label widget and in graphic page widget
 */
export enum ImagePosition {
    LEFT = "1",
    RIGHT = "2",
    UP = "3",
    DOWN = "4"
}
